var elShopSection = document.querySelector( '.js-hoox-shop' );
var elProductData = elShopSection?.querySelector( '.js-hoox-shop-product' );
var product = elProductData && JSON.parse( elProductData.textContent );
var hooxDelay = 300;
var isMobile = window.innerWidth < 768;

onOptionClick();
renderImages();
priceHandler();
quantityHandler();
shopSaveHandler();
galleryMobileHandler();
stickyBarScrollHandler();
shopAccordion();
stickyWrapperParentHeight();

function onOptionClick() {
	var elOptions = elShopSection.querySelectorAll( '.variant-picker__option input' );
	elOptions.forEach( function ( option ) {
		option.addEventListener( 'click', function () {
			setTimeout( function () {
				if ( option.closest( '.variant-picker__option' )?.querySelector( '.color-swatch' ) ) {
					var elMobGallery = document.querySelector('.hoox-shop__gallery-mob');
					if (elMobGallery?.swiper) {
						elMobGallery.swiper.destroy(true, true);
						runGallerySlider();
					}
					renderImages();
				}

				priceHandler();
				updateStickyBarVariantTitle();
				shopSaveHandler();
			}, hooxDelay );
		} );
	} );
}

function renderImages() {
	var color = getCurrentVariant()[ getColorOptionPosition() ];
	if ( !color ) return [];

	var elImagesWrapper = elShopSection.querySelector( '.hoox-shop__gallery' );
	var imgCount = elShopSection.dataset.imagesCount;

	var imgs = product.media
		.filter( function ( media ) {
			return media.alt === `#color_${ color.toLowerCase() }` && media.media_type === 'image';
		} )
		.slice( 0, imgCount )
	;

	if ( !!imgs.length ) {
		if ( elImagesWrapper.querySelector( 'img' ) ) {
			elImagesWrapper.querySelectorAll( 'img' ).forEach( function ( item, index ) {
				item.src = imgs[ index ].src;
				item.alt = getCurrentVariant().title;
			} );
		} else {
			elImagesWrapper.innerHTML = '';
			imgs.forEach( function ( img ) {
				var elImg = document.createElement( 'img' );
				elImg.src = img.src;
				elImg.alt = getCurrentVariant().title;
				elImg.width = 300;
				elImg.height = 353;

				elImagesWrapper.appendChild( elImg );
			} );
		}
	}

	// Update sticky bar image
	var stickyBarImage = elShopSection.querySelector('.hoox-shop-sticky__image');
	if (stickyBarImage) {
		stickyBarImage.src = imgs[0].src;
		stickyBarImage.alt = getCurrentVariant().title;
		stickyBarImage.title = getCurrentVariant().title;
	}
}

function getCurrentVariant() {
	var id = elShopSection?.querySelector( 'form input[name="id"]' )?.value;

	if ( !id ) return;

	return product.variants.find( function ( variant ) {
		return +variant.id === +id;
	} );
}

function updateStickyBarVariantTitle() {
	var elTitle = elShopSection.querySelector('.hoox-shop-sticky__title-variant');
	if (elTitle) {
		elTitle.innerHTML = '';
		getCurrentVariant().options.forEach(function (option) {
			var spanElement = document.createElement('span');
			spanElement.textContent = option;
			elTitle.appendChild(spanElement);
		});
	}
}

function priceHandler() {
	setTimeout( function () {
		var elBtn = elShopSection?.querySelector( '.buy-buttons button' );
		if ( elBtn ) {
			var quantity = elShopSection.querySelector( '.quantity-selector__input' ).value;
			var classPriceWrapper = 'hoox-shop__price-wrapper';
			var classPrice = 'hoox-shop__price';
			var classPriceCompare = 'hoox-shop__price-compare';
			var variant = getCurrentVariant();
			var price = variant.price;
			var priceCompare = variant.compare_at_price;
			var elPriceWrapper = elShopSection.querySelector( `.${ classPriceWrapper }` );

			if ( elPriceWrapper ) {
				var elPrice = elShopSection.querySelector( `.${ classPrice }` );
				var elPriceCompare = elShopSection.querySelector( `.${ classPriceCompare }` );

				if ( elPrice ) {
					elPrice.innerHTML = priceFormatterHandler( +price * +quantity );
				}

				if ( priceCompare ) {
					elPriceCompare.innerHTML = priceFormatterHandler( +priceCompare * +quantity );
				} else {
					elPriceCompare.innerHTML = '';
				}
			} else {
				var newElPriceWrapper = document.createElement( 'span' );
				newElPriceWrapper.classList.add( classPriceWrapper );
				var newElPrice = document.createElement( 'span' );
				newElPrice.classList.add( classPrice );
				newElPrice.innerHTML = priceFormatterHandler( +price * +quantity );
				newElPriceWrapper.appendChild( newElPrice );

				if ( priceCompare ) {
					var newElPriceCompare = document.createElement( 'del' );
					newElPriceCompare.classList.add( classPriceCompare );
					newElPriceCompare.innerHTML = priceFormatterHandler( +priceCompare * +quantity );
					newElPriceWrapper.appendChild( newElPriceCompare );
				}

				elBtn.appendChild( newElPriceWrapper );
			}
		}
	}, hooxDelay );
}

function quantityHandler() {
	var elQuantityBtns = elShopSection?.querySelectorAll( '.quantity-selector__button' );
	var elQuantityInput = elShopSection?.querySelector( '.quantity-selector__input' );
	if ( !!elQuantityBtns ) {
		elQuantityBtns.forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				priceHandler();
			} );
		} );
	}
	if ( !!elQuantityInput ) {
		elQuantityInput.addEventListener( 'change', function () {
			priceHandler();
		} );
	}
}

function getColorOptionPosition() {
	// Define an object to map indices to option names
	var optionMap = {
		1: 'option1',
		2: 'option2',
		3: 'option3'
	};

	var colorIndex = product.options.indexOf( 'Colour' );

	if ( colorIndex === -1 ) {
		colorIndex = product.options.indexOf( 'Color' );
	}

	var index = colorIndex + 1;
	return optionMap[ index ] || '';
}

function galleryMobileHandler() {
	if ( isMobile ) {
		var elGallery = elShopSection?.querySelector( '.hoox-shop__gallery' );
		var elGalleryMob = elShopSection?.querySelector( '.hoox-shop__gallery-mob' );
		var elGalleryMobPagination = document.createElement( 'div' );
		elGalleryMobPagination.classList.add( 'hoox-shop__gallery-mob-dots' );
		elGalleryMob.classList.add( 'swiper' );
		elGallery.classList.add( 'swiper-wrapper' );
		elGallery.querySelectorAll( 'img' ).forEach( function ( img ) {
			img.classList.add( 'swiper-slide' );
		} );
		elGalleryMob.appendChild( elGallery );
		elGalleryMob.appendChild( elGalleryMobPagination );

		runGallerySlider();
	}
}

function runGallerySlider() {
	if ( isMobile ) {
		var shopSwipper = new Swiper( '.hoox-shop__gallery-mob', {
			loop: true,
			infinite: true,
			slidesPerView: 1.15,
			spaceBetween: 24,

			pagination: {
				el: '.hoox-shop__gallery-mob-dots',
				clickable: true,
			},
		} );
	}
}

function shopSaveHandler() {
	var elSave = elShopSection.querySelector('.hoox-shop__save span');
	if (elSave) {
		var price = getCurrentVariant().price;
		var priceCompare = getCurrentVariant().compare_at_price;
		if (priceCompare && price < priceCompare) {

			elSave.innerHTML = `${Math.round(((priceCompare - price) / priceCompare) * 100)}%`;
		}
	}
}

function shopAccordion() {
	var accordions = elShopSection.querySelectorAll('.hoox-shop__accordion-item');

	if (!!accordions.length) {
		accordions.forEach(function(item) {
			var header = item.querySelector('.hoox-shop__accordion-header');

			header.addEventListener('click', function() {
				item.classList.toggle('active');
			});
		});
	}
}

function stickyBarScrollHandler() {
	var classActive = 'active';
	var element = document.querySelector( '.hoox-shop-sticky' );
	var isInViewport = function ( elem ) {
		var rect = elem.getBoundingClientRect();
		return (
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) &&
			rect.left <= ( window.innerWidth || document.documentElement.clientWidth )
		);
	};

	var debounce = function ( func, delay ) {
		var timeout;
		return function () {
			var context = this;
			var args = arguments;
			clearTimeout( timeout );
			timeout = setTimeout( function () {
				func.apply( context, args );
			}, delay );
		};
	};

	var handleScroll = function () {
		var targetSections = [
			document.querySelector( '.hoox-hero' ),
			document.querySelector( '.hoox-shop' ),
			document.querySelector( '.footer' ),
			document.querySelector( '.hoox-footer' ),
		];

		var isAnySectionInView = targetSections.some( function ( section ) {
			return section && isInViewport( section );
		} );

		if ( isAnySectionInView ) {
			element.classList.remove( classActive );
		} else {
			element.classList.add( classActive );
		}
	};

	var debouncedScroll = debounce( handleScroll, 0 ); // Adjust the debounce delay as needed

	window.addEventListener( 'scroll', debouncedScroll );

	// // Call handleScroll once to show the button on load
	// window.addEventListener( 'load', function () {
	// 	handleScroll();
	// } );
}

function stickyWrapperParentHeight() {
	var element = document.querySelector( '.hoox-shop-sticky' );
	var parent = element?.closest( '.hoox-shop-sticky-wrapper' );
	if (parent) {
		element.parentElement.style.height = element.clientHeight + 'px';
	}

}

function priceFormatterHandler( price ) {
	const formatter = new Intl.NumberFormat( 'en-US', {
		style: 'currency',
		currency: window?.Shopify?.currency?.active || 'USD',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	} );

	return formatter.format( price / 100 );
}
